import { Input, InputNumber } from "antd";
import * as React from "react";
import NumberFormatter from "../../../model/common/NumberFormatter";

interface Props {
  value: number;
  onBlur: any;
  required?: boolean;
  placeholder?: string;
  style?: any;
  onChange: (value: number | undefined) => void;
  onFocus?: any;
}

interface State {}

const formatter = NumberFormatter();

export default class IntField extends React.Component<Props, State> {
  render() {
    const {
      onBlur = () => {},
      placeholder,
      required,
      style,
      onChange,
      onFocus,
      value
    } = this.props;

    return (
      <Input
        style={{ ...style, textAlign: "right" }}
        value={value}
        onChange={(e) => {
          let value: string | number | undefined = e.currentTarget.value;
          value = formatter.removeNonallowedChars(value);
          value = formatter.removeDecimals(value);
          value = value ? Number(value) : undefined;
          onChange(value);
        }}
        onBlur={onBlur}
        placeholder={placeholder}
        required={required}
        onFocus={onFocus}
      />
    );
  }
}
